import { slightBluishTintColor } from "../../../config/ColorObj";
import { styles } from "../styles/SalesPersonWithChallanData";

// ─── SVG Icons (Lightweight & Performant) ────────────────────────────────────
export const Icon = ({ type, size = 16, color = "currentColor" }) => {
    const props = { width: size, height: size, fill: "none", stroke: color, strokeWidth: 2 };

    switch (type) {
        case "outlet":
            return (
                <svg {...props} viewBox="0 0 24 24">
                    <path d="M3 10l9-7 9 7v10a1 1 0 0 1-1 1h-4v-6H8v6H4a1 1 0 0 1-1-1z" />
                </svg>
            );

        case "product":
            return (
                <svg {...props} viewBox="0 0 24 24">
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <path d="M3 9h18M9 21V9" />
                </svg>
            );

        case "calendar":
            return (
                <svg {...props} viewBox="0 0 24 24">
                    <rect x="3" y="5" width="18" height="16" rx="2" />
                    <path d="M16 3v4M8 3v4M3 11h18" />
                </svg>
            );

        case "qty":
            return (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M3 3H5L5.4 5M5.4 5H21L17 13H7M5.4 5L7 13M7 13L5.3 15H17M17 18C17 18.6 17.4 19 18 19C18.6 19 19 18.6 19 18C19 17.4 18.6 17 18 17C17.4 17 17 17.4 17 18ZM7 18C7 18.6 7.4 19 8 19C8.6 19 9 18.6 9 18C9 17.4 8.6 17 8 17C7.4 17 7 17.4 7 18Z" stroke="#185FA5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            );

        case "top":
            return (
                <svg {...props} viewBox="0 0 24 24">
                    <path d="M12 17l-5 3 1-5-4-3 5-.5L12 6l3 5.5 5 .5-4 3 1 5z" />
                </svg>
            );

        default:
            return null;
    }
};


export const ExternalLinkIcon = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" style={styles.externalIcon}>
        <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
        <polyline points="15 3 21 3 21 9" />
        <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
);
export const ChevronIcon = ({ open }) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2.5"
        style={{ ...styles.chevronSvg, transform: open ? "rotate(180deg)" : "rotate(0deg)" }}>
        <polyline points="6 9 12 15 18 9" />
    </svg>
);